import auth from '@/router/auth'

export default [
  {
    path: '/sub-users',
    name: 'list-manager',
    component: () => import('@/components/manager/Index'),
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/manager/router.js